import ViewBase from '../../views/view-base.view';
import HeaderPublicLayout from '../../layout/header-public.layout';
import DownloadModel from '../../models/download.model';

export default function DownloadView() {
  ViewBase.call(this);
  let fileId = '';
  let fileNotFound = false;
  let isDownloading = true;
  let isSuccessful = false;

  let getDownloadFileId = () => {
    fileId = m.route.param("fileId") ?? '';

    if (fileId === '') {
      fileNotFound = true;
    }

    return !fileNotFound;
  }

  let downloadFile = () => {
    isDownloading = true;
    DownloadModel.downloadByFileId(fileId)
      .then(() => { isSuccessful = true; })
      .catch(error => {
        isSuccessful = false;
        this.handleError(error);
      })
      .finally(() => {
        isDownloading = false;
      });
  }

  return {
    oncreate: (vnode) => {
      if (getDownloadFileId()) {
        downloadFile();
      } else {
        isDownloading = false;
        isSuccessful = false;
        m.redraw();
      }
    },
    view: (vnode) => {
      return [
        m(HeaderPublicLayout),
        m('.d-flex.justify-content-center.align-items-center',
          m('.pt-5',
            fileNotFound
              ? 'File not found'
              : [
                isDownloading
                  ? ['Downloading file... ', m('span.spinner-border.spinner-border-sm.ms-3.mb-1[role=status][aria-hidden=true]')]
                  : isSuccessful
                    ? 'File download completed. You may close this window / tab.'
                    : 'File download failed'
              ]
          ),
        ),
        this.getBaseViews()];
    },
  };
}
